import { Component } from '@angular/core';
import { authCodeFlowConfig } from './auth.config'
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet
  ]
})
export class AppComponent {
  constructor(private oauthService: OAuthService) {
    console.log('AppComponent, configuring OAuthService')
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.setStorage(sessionStorage)

    this.oauthService.events.subscribe((event: any) => {
      if (event instanceof OAuthErrorEvent) {
        console.error('OAuthErrorEvent Object:', event)
      } else {
        console.warn('OAuthEvent Object:', event)
      }
    })
  }
}
